import { createContext, useContext } from 'react';
import { DataViewContextData as ContextData } from './types';

const context = createContext<ContextData>({} as ContextData);

export const { Provider } = context;

export const useDataViewContext = () => useContext(context);

/** Chart-only slice so consumers that only need isChartView don't re-render when viewItems or handleSwitchView change. */
const chartContext = createContext<{ isChartView: boolean }>({
  isChartView: false,
});

export const DataViewChartProvider = chartContext.Provider;

export const useDataViewChartView = () => useContext(chartContext);
